<template>
  <scroll-area class="work-area workarea fds" ref="workArea">
    <div class="object-model-default-actions">
      <base-object-model-action
          class="object-model-default-action"
          v-for="defaultAction in objectModelDefaultActions"
          :key="defaultAction.client_id"
          :object-model-action="defaultAction"
      ></base-object-model-action>
    </div>
    <hr>
    <div class="object-model-actions">
      <template v-if="objectModelActions.length">
        <base-object-model-action
          class="object-model-action om-action-draggable om-action-droppable"
          v-for="objectModelAction in objectModelActions"
          :key="objectModelAction.client_id"
          :object-model-action="objectModelAction"
          @remove="removeAction"></base-object-model-action>
      </template>
      <div v-else class="drop-in-zone empty">
        <p><b>Drag and Drop</b> action types here.</p>
      </div>
    </div>
  </scroll-area>
</template>

<script lang="ts">
  import Vue from "vue";
  import BaseObjectModelAction from "./base-object-model-action.vue";
  import storeMapper from "../../../common/mixins/storeMappers/storeMapper";
  import ObjectModelAction from "../../../common/models/objectModelActions/objectModelAction";
  import workareaDragMixin from "../../../common/mixins/drag/workareaDragMixin";
  import routerMixin from "../../../common/mixins/routerMixin";
  import selectedMixin from "../mixins/selectedMixin";
  import {BuilderArea} from "../enums/builder-area";
  import ObjectModel from "../../../common/models/objectModel";
  import {Hash} from "../../../common/interfaces/hashInterfaces";

  const objectModelStoreMixin = storeMapper('objectModelStore', {state: ['objectModel']});

  export default Vue.extend({
    components: {
      BaseObjectModelAction,
    },
    mixins: [
      objectModelStoreMixin,
      workareaDragMixin,
      routerMixin,
      selectedMixin,
    ],
    data: function () {
      return {
        draggableClasses: ['om-action-draggable'],
        droppableClasses: ['om-action-droppable', 'model-builder'],
        dragArea: BuilderArea.actions,
      };
    },
    computed: {
      objectModelDefaultActions(): ObjectModelAction[] {
        return this.objectModel.objectModelDefaultActionsArray;
      },
      objectModelActions(): ObjectModelAction[] {
        return this.objectModel.objectModelActionsArray;
      },
      targetRoot(): ObjectModel {
        return this.objectModel;
      }
    },
    methods: {
      removeAction(action: ObjectModelAction): void {
        action.destroy();
      }
    },
  });
</script>